import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeDrawer, {MoleculeDrawerOverlay, moleculeDrawerPlacements} from '@s-ui/react-molecule-drawer'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import NetFeedback from '@adv-mt/mt-net-feedback'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

const BASE_CLASS = 'mt-Net-reviewDrawer'

const ReviewDrawer = ({isOpen, onSuccess, onCancel}) => {
  const {i18n} = useSuiContext()

  return (
    <>
      <MoleculeDrawerOverlay isVisible={isOpen} />
      <MoleculeDrawer closeOnOutsideClick isOpen={isOpen} onClose={onCancel} placement={moleculeDrawerPlacements.RIGHT}>
        {isOpen && (
          <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}-header`}>
              <PrimitiveTypography design={primitiveTypographyDesign.HEADLINE_2} className={`${BASE_CLASS}-title`}>
                {i18n.t('NET.FEEDBACK.HEADER_TITLE')}
              </PrimitiveTypography>
              <AtomButton
                onClick={onCancel}
                aria-label={i18n.t('NET.CLOSE_CHAT')}
                design={atomButtonDesigns.FLAT}
                leftIcon={
                  <AtomIcon size={ATOM_ICON_SIZES.medium}>
                    <IconClose />
                  </AtomIcon>
                }
              />
            </div>
            <div className={`${BASE_CLASS}-content`}>
              <NetFeedback onSuccess={onSuccess} onFinish={onCancel} />
            </div>
          </div>
        )}
      </MoleculeDrawer>
    </>
  )
}

ReviewDrawer.displayName = 'ReviewDrawer'
ReviewDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default ReviewDrawer
